import axiosInstance from 'src/utils/axios';
import { ENDPOINTS } from './endpoints';

export async function getExcelTemplate(type) {
  return downloadExcelFile(ENDPOINTS.excel.get_template(type));
}

export async function downloadExcelFile(url) {
  var response = await axiosInstance.get(url, {
    responseType: 'blob',
  });
  const contentDisposition = response.headers.get('content-disposition');
  let fileName = 'sample_file.xlsx';

  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename=(.+?);/);
    if (fileNameMatch.length === 2) {
      fileName = fileNameMatch[1];
    }
  }

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(link);
  return;
}
